export default __webpack_public_path__ + "images/D9.785e63c.png";